import apiFetch from '../apiFetch'

export default function (values, token) {
  return apiFetch({endPoint: `Envasado/filtrarEnvasado`, method: 'POST', body: values, token: token})
}
